import { useEffect } from "react";
import { Textfit } from "react-textfit";
import type { ToolListItem } from "src/pods/toolkitData/components/EditableSetup";
import logEvent from "src/utils/logEvent";
import styles from "./DirectionsDisplay.module.css";

type DirectionsDisplayProps = {
  title?: string;
  list?: ToolListItem[];
};

export default function DirectionsDisplay({ title, list }: DirectionsDisplayProps) {
  useEffect(() => {
    logEvent({ eventName: "directions.result.open" });
    return () => {
      logEvent({ eventName: "directions.result.close" });
    };
  }, []);

  return (
    <article className={styles.card}>
      <Textfit className={styles.textfit}>
        {title && <h1 className={styles.title}>{title}</h1>}
        <ol className={styles.list}>
          {list?.map((item, idx) => (
            <li key={idx} className={styles.item}>
              <span className={styles.itemCount}>{idx + 1}</span>
              <p className={styles.itemText}>{item.text}</p>
            </li>
          ))}
        </ol>
      </Textfit>
    </article>
  );
}
